import { RefObject } from 'react';
import { ContextProps, SelectActions, State } from './interfaces';

export const useSelectContextUtils = <ObjectType>(
    optionElements: HTMLDivElement[],
    setOptionElements: React.Dispatch<React.SetStateAction<HTMLDivElement[]>>,
    state: State<ObjectType>,
    setState: React.Dispatch<React.SetStateAction<State<ObjectType>>>,
    selectButtonElement: HTMLButtonElement | null,
    initialValueHandled: RefObject<boolean>,
) => {
    const registerOption: ContextProps<ObjectType>['registerOption'] = (optionElement) => {
        setOptionElements((currentOptions) => [...currentOptions, optionElement]);

        return {
            unregisterOption: (currentOption) => {
                setOptionElements((currentOptions) => {
                    return currentOptions.filter((optionElementToCompare) => currentOption !== optionElementToCompare);
                });
            },
        };
    };

    const selectActions: SelectActions<ObjectType> = {
        initialValueHandled: !!initialValueHandled.current,
        selectedValue: state.selectedValue,
        selectOption: (params) => {
            const { shouldFocus = true, ...nextParams } = params;
            setState({
                ...state,
                ...nextParams,
                expanded: false,
                height: '0px',
            });
            if (shouldFocus) {
                selectButtonElement?.focus();
            }
        },
        focusNextOption: (currentOptionElement) => {
            const optionIndex = optionElements.indexOf(currentOptionElement);
            const targetIndex = optionIndex + 1;
            optionElements[targetIndex === optionElements.length ? 0 : targetIndex].focus();
        },
        focusPreviousOption: (currentOptionElement) => {
            const optionIndex = optionElements.indexOf(currentOptionElement);
            const targetIndex = optionIndex - 1;
            optionElements[targetIndex < 0 ? optionElements.length - 1 : targetIndex].focus();
        },
        closeIfUnfocusingSelect: (currentOptionElement, focusDirection) => {
            const optionIndex = optionElements.indexOf(currentOptionElement);
            const indexIfCollapseNeeded = focusDirection === 'down' ? optionElements.length - 1 : 0;

            if (optionIndex === indexIfCollapseNeeded) {
                setState({
                    ...state,
                    expanded: false,
                    height: '0px',
                });
            }
        },
        close: () => {
            setState({
                ...state,
                expanded: false,
                height: '0px',
            });
        },
    };

    return { registerOption, selectActions };
};
